import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { DISTRIBUTION_JOBS_API } from "./apiRoutes";
interface UseGetDistributionJobsSimulatePlannedProps {
  communityId: string;
  budgetId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getDistributionJobsSimulatePlanned = async (budgetId: string, communityId: string) =>
  await axiosAuth.post(`${DISTRIBUTION_JOBS_API(communityId)}/plan/simulate/${budgetId}`);

const useGetDistributionJobsSimulatePlanned = ({
  queryParams,
  budgetId,
  communityId
}: UseGetDistributionJobsSimulatePlannedProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["distribution-jobs-simulate-planned", budgetId],
    queryFn: () => getDistributionJobsSimulatePlanned(budgetId, communityId),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    enabled: !!budgetId || queryParams?.enabled,
    ...queryParams,
  });
};

export default useGetDistributionJobsSimulatePlanned;
